import VariantColors from "./product--variant-colors.js";

class VariantFabrics extends VariantColors {
  connectedCallback() {
    this.addEventListeners();
    this.resetUnavailableProductHandels();
  }

  resetUnavailableProductHandels() {
    this.querySelectorAll("label").forEach((label) => {
      const input = label.previousElementSibling;
      const unavailableProducts = this.dataset.unavailableProducts.split(",");
      const colors = this.dataset.colors
        .split(",")
        .map((color) => color.trim().toLowerCase().replace(/ /g, "-"));
      const fabric = label.dataset.fabric.split(" ").join("-");
      if (input.disabled) {
        const newFabricHandle = colors
          .map((color) =>
            unavailableProducts.find(
              (handle) => handle.includes(fabric) && handle.includes(color),
            ),
          )
          .find((handle) => handle);
        label.dataset.product = newFabricHandle;
      }
    });
  }
}

export default VariantFabrics;
